"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _NormalInput = _interopRequireDefault(require("./NormalInput"));

var _MultilineInput = _interopRequireDefault(require("./MultilineInput"));

var _BorderInput = _interopRequireWildcard(require("./BorderInput.style"));

var BorderInput = function BorderInput(_ref) {
  var className = _ref.className,
      style = _ref.style,
      inputClassName = _ref.inputClassName,
      inputStyle = _ref.inputStyle,
      disabled = _ref.disabled,
      multiline = _ref.multiline,
      error = _ref.error,
      warning = _ref.warning,
      errorClassName = _ref.errorClassName,
      other = (0, _objectWithoutProperties2.default)(_ref, ["className", "style", "inputClassName", "inputStyle", "disabled", "multiline", "error", "warning", "errorClassName"]);
  return _react.default.createElement(_BorderInput.default, {
    className: className,
    style: style,
    disabled: disabled || false,
    error: error,
    warning: warning
  }, !multiline && _react.default.createElement(_NormalInput.default, (0, _extends2.default)({}, other, {
    className: inputClassName,
    style: inputStyle,
    disabled: disabled || false
  })), multiline && _react.default.createElement(_MultilineInput.default, (0, _extends2.default)({}, other, {
    className: inputClassName,
    disabled: disabled || false
  })), (error || warning) && _react.default.createElement("span", {
    className: (0, _classnames.default)((0, _BorderInput.errorLabel)(error), errorClassName)
  }, error || warning));
};

BorderInput.propTypes = (0, _objectSpread2.default)({}, _NormalInput.default.propTypes, {
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  inputClassName: _propTypes.default.string,
  inputStyle: _propTypes.default.object,
  error: _propTypes.default.string,
  warning: _propTypes.default.string,
  errorClassName: _propTypes.default.string
});
BorderInput.defaultProps = (0, _objectSpread2.default)({}, _NormalInput.default.defaultProps, {
  className: '',
  style: {},
  inputClassName: '',
  inputStyle: {},
  error: '',
  warning: '',
  errorClassName: ''
});
var _default = BorderInput;
exports.default = _default;